module.exports = __webpack_public_path__ + "static/media/nav-icon-account-mapping.e652f50b.svg";